import { toast } from "react-toastify";
import { convertToDecimal, getConvertValue, getNumericBase, getPowerExponent } from "./featureAnalysisUtils";
import moment from "moment";
import { getWhatIfAnalysisFetchFeatures, getWhatIfAnalysisPrediction } from "../../../api/sensorApi";

export const predictHandler = (sensorID, units, setLoadingPredictCR, setPredictCRate, changeFeatureList, scenarioFeatures, featureValueList, viscosityNumber, viscosityPower) => {
    setLoadingPredictCR(true);
    setPredictCRate(null);
    const featureObj = changeFeatureList.reduce(function (result, current) {
        return Object.assign(result, current);
    }, {});

    const indexOfMaterial = scenarioFeatures.findIndex(
        (obj) => Object.keys(obj)[0] === "Material"
    );
    const indexOfPosition = scenarioFeatures.findIndex(
        (obj) => Object.keys(obj)[0] === "Position"
    );

    let count = 0;
    for (const key in featureObj) {
        if (key.startsWith("Position")) {
            if (key.endsWith("" + featureValueList[indexOfPosition])) {
                featureObj[key] = [1];
            } else {
                featureObj[key] = [0];
            }
        } else if (key.startsWith("Material")) {
            if (key.endsWith("" + featureValueList[indexOfMaterial])) {
                featureObj[key] = [1];
            } else {
                featureObj[key] = [0];
            }
        } else {
            if (units) {
                featureObj[key] = [getConvertValue(key, +featureValueList[count])];
            } else {
                featureObj[key] = [featureValueList[count]];
            }
            count += 1;
        }
    }

    // Change the value of "Viscosity" property
    featureObj["Viscosity"] = [convertToDecimal(viscosityNumber, viscosityPower) + ''];

    // Channging the value of the feature if it is changed by the user

    // Transform the original feature values to the format required by the API
    const transformedFeatures = changeFeatureList.reduce((acc, feature) => {
        const propertyName = Object.keys(feature)[0];
        const value = feature[propertyName];
        acc[propertyName] = [value + ''];
        return acc;
    }, {});

    // Check if the edited features in feature[obj] are different from the original features
    Object.keys(transformedFeatures).forEach(key => {
        const roundedValue = Math.round(transformedFeatures[key] * 1000) / 1000;
        const roundedFeatureValue = Math.round(featureObj[key] * 1000) / 1000;
        // If the values are different, then update the transformedFeatures object
        if (roundedValue !== roundedFeatureValue && key !== "Viscosity") {
            transformedFeatures[key] = featureObj[key];
        }
        if (key === "Viscosity") {
            const ogBase = getNumericBase(Number(transformedFeatures[key]), units)
            const ogPower = getPowerExponent(Number(transformedFeatures[key]), units)
            const ogValue = convertToDecimal(ogBase, ogPower) + ''
            if (ogValue !== featureObj[key]) {
                transformedFeatures[key] = featureObj[key];
            }
        }

    });

    getWhatIfAnalysisPrediction({
        sensor_id: sensorID,
        data: { ...transformedFeatures },
    }).then((data) => {
        setPredictCRate(data["analysis_prediction"]);
        setLoadingPredictCR(false);
    }).catch(err => {
        console.error(err);
        toast.error("Error getting prediction")
        setLoadingPredictCR(false);
    });
};


export const featureChangeHandler = (value, feature, index, featureMinMax, featureStdMinMax, setFeatureValueList, precentageFeature, seterrorText) => {

    const findMinMax = featureMinMax.find((obj) => obj.path === feature);
    const findStdMinMax = featureStdMinMax.find((obj) => obj.path === feature);

    setFeatureValueList((prevState) => {
        const showList = [...prevState];
        if (feature === 'Position' || feature === 'Material') {
            showList[index] = value;
        }
        else {
            // Percentage Features
            if (precentageFeature.includes(feature)) {
                showList[index] =
                    parseInt(value) > 100 ? "100" : parseInt(value) < 0 ? "" : value;
            }
            else {
                showList[index] = value;
            }
        }
        return showList;
    });

    seterrorText((prevState) => {
        const showList = [...prevState];
        if (precentageFeature.includes(feature)) {
            showList[index] =
                parseInt(value) > 100 || parseInt(value) < 0
                    ? "Valid Input from 0 to 100"
                    : null;
        } else if (findMinMax !== undefined && findStdMinMax !== undefined) {
            if (findMinMax.min === findMinMax.max) {
                showList[index] = `Model Trained on static data.`
            }
            else {
                showList[index] = `Model Trained from ${findMinMax.min} to ${findMinMax.max}`
                if (parseInt(value) > findStdMinMax.stdMax || parseInt(value) < findStdMinMax.stdMin) {
                    showList[index] = `Please enter the value within the ${findStdMinMax.stdMin} to ${findStdMinMax.stdMax}`
                }
            }

        }
        return showList;
    });
};


export const submitForm = (sensorID, setscenarioFeatures, setPredictCRate, crDate, setCorrosionRateData, setPositionAndMaterial) => {
    setscenarioFeatures(null);
    setPredictCRate(null);
    if (crDate) {
        getWhatIfAnalysisFetchFeatures({
            sensor_id: sensorID,
            selected_date: moment(crDate).add(1, "day").format("YYYY-MM-DD"),
        }).then((data1) => {
            if (data1?.length > 0) {
                const removeTarget = data1.filter((obj) => {
                    if (obj["target"] !== undefined) {
                        setCorrosionRateData(obj["target"]);
                        return false;
                    }
                    return true;
                });
                setPositionAndMaterial(data1, removeTarget);
            }
        }).catch((err) => {
            console.error(err);
            toast.error("Error getting corrosion rate data")
        }
        );
    }
};